import { CommonModule } from "@angular/common";
import { Component, computed, ElementRef, HostListener, inject, OnInit, signal, viewChild } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { PermissionActionDescriptorType } from "../../../adaa-types";
import { ConsoleIconComponent } from "../../shared/components";
import { Language, PermissionAction } from "../../shared/constants/enums";
import { HasPermissionDirective } from "../../shared/directives";
import type { PermissionActionModelType } from "../../shared/models";
import { ConsoleService, LanguageService } from "../../shared/services";

@Component({
  imports: [HasPermissionDirective, TranslatePipe, CommonModule, ConsoleIconComponent],
  templateUrl: "./console.html",
  styleUrl: "./console.scss",
})
export class ConsoleComponent implements OnInit {
  private readonly _consoleService = inject(ConsoleService);
  readonly languageService = inject(LanguageService);

  consoleSearch = viewChild<ElementRef<HTMLElement>>("consoleSearch");

  showSearch = signal(false);
  searchTerm = signal("");

  @HostListener("window:keydown", ["$event"])
  public handleKeyDown(event: KeyboardEvent) {
    const key = event.key.toLowerCase();

    if ((event.ctrlKey || event.metaKey) && (key === "f" || key === "ب")) {
      event.preventDefault();

      this.showSearch.update((e) => !e);
      this.searchTerm.set("");

      setTimeout(() => {
        this.consoleSearch()?.nativeElement?.focus();
      }, 500);
    } else if (key === "escape") {
      this.showSearch.set(false);
      this.searchTerm.set("");
    }
  }

  displayedConsoleItems = computed(() => {
    const key = this.languageService.current() === Language.Arabic ? "nameAE" : "nameEN";
    return (this._consoleService.consoleItems() ?? []).filter((e) =>
      e[key].toLowerCase().includes(this.searchTerm().toLowerCase())
    );
  });

  public ngOnInit(): void {
    this._consoleService.init();
  }

  public getPermission(permissionId: string | undefined): PermissionActionDescriptorType | undefined {
    if (permissionId) {
      const permissions = permissionId.split(",");
      const permissionsArray: PermissionActionModelType[] = [];

      permissions.forEach((e) => {
        permissionsArray.push(
          {
            permissionAction: PermissionAction.view,
            objectTypeId: +e,
          },
          {
            permissionAction: PermissionAction.manage,
            objectTypeId: +e,
          },
          {
            permissionAction: PermissionAction.execute,
            objectTypeId: +e,
          }
        );
      });

      return {
        actor: {
          modifier: "or",
          permissions: permissionsArray,
        },
      };
    } else return undefined;
  }

  public onSearch(event: Event) {
    this.searchTerm.set((event.target as HTMLInputElement).value);
  }
}
